import React from 'react';
import { NavLink } from 'react-router-dom';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Banner from '../Elements/Banner';
import SiteContentContext from '../../content/SiteContentContext';
import { getByPath, resolveMediaSrc } from '../../content/siteContentUtils';

var bnrimg = require('./../../images/banner/4.jpg');

const fallbackCategoryProducts = {
    apartment: [
        {
            image: require('./../../images/products/pic-1.jpg'),
            name: 'Modern Daire Giris Kapisi',
            code: 'DGK-001',
            description: 'Daire girislerinde guvenlik ve estetik ihtiyacina uygun model.',
        },
        {
            image: require('./../../images/products/pic-2.jpg'),
            name: 'Klasik Daire Kapisi',
            code: 'DGK-002',
            description: 'Klasik cizgileri modern guvenlik altyapisi ile birlestirir.',
        },
        {
            image: require('./../../images/products/pic-3.jpg'),
            name: 'Lake Daire Kapisi',
            code: 'DGK-003',
            description: 'Mekanla uyumlu renk secenekleri ve kaliteli yuzey isciligi sunar.',
        },
    ],
    villa: [
        {
            image: require('./../../images/products/pic-4.jpg'),
            name: 'Villa Kapisi Modern',
            code: 'VKM-001',
            description: 'Villa projeleri icin ozel olcu ve tasarim secenekleri sunar.',
        },
        {
            image: require('./../../images/products/pic-5.jpg'),
            name: 'Villa Kapisi Ahsap Desen',
            code: 'VKM-002',
            description: 'Ahsap gorunumlu, guclendirilmis govde yapisi ile uzun omurludur.',
        },
        {
            image: require('./../../images/products/pic-6.jpg'),
            name: 'Villa Kapisi Premium',
            code: 'VKM-003',
            description: 'Yuksek guvenlikli kilit sistemi ve premium gorunum sunar.',
        },
    ],
    building: [
        {
            image: require('./../../images/products/pic-7.jpg'),
            name: 'Bina Giris Kapisi 1',
            code: 'BGK-001',
            description: 'Apartman ve site girisleri icin dayanikli ve sik cozum.',
        },
        {
            image: require('./../../images/products/pic-8.jpg'),
            name: 'Bina Giris Kapisi 2',
            code: 'BGK-002',
            description: 'Yuksek kullanim yogunluguna uygun govde ve kaplama yapisi.',
        },
        {
            image: require('./../../images/products/pic-4.jpg'),
            name: 'Bina Giris Kapisi 3',
            code: 'BGK-003',
            description: 'Kurumsal ve toplu yasam alanlari icin ideal model.',
        },
    ],
    interior: [
        {
            image: require('./../../images/products/pic-3.jpg'),
            name: 'Ic Kapi Lake',
            code: 'ICK-001',
            description: 'Ic mekanlarda sade ve modern bir gorunum saglar.',
        },
        {
            image: require('./../../images/products/pic-1.jpg'),
            name: 'Ic Kapi Panel',
            code: 'ICK-002',
            description: 'Farkli dekorasyon stillerine uyumlu panel tasarim.',
        },
        {
            image: require('./../../images/products/pic-2.jpg'),
            name: 'Ic Kapi Klasik',
            code: 'ICK-003',
            description: 'Klasik cizgileri ile ic mekanlarda sicak bir atmosfer olusturur.',
        },
    ],
};

const normalizeProductImageUrls = (item, fallbackImage) => {
    const configuredList = Array.isArray(item?.imageUrls) ? item.imageUrls : [];
    const cleanedConfiguredList = configuredList
        .map((value) => (typeof value === 'string' ? value.trim() : ''))
        .filter(Boolean);

    if (cleanedConfiguredList.length > 0) {
        return cleanedConfiguredList;
    }

    const singleImage = typeof item?.imageUrl === 'string' ? item.imageUrl.trim() : '';
    if (singleImage) {
        return [singleImage];
    }

    return fallbackImage ? [fallbackImage] : [];
};

class ProductCategoryGridPage extends React.Component {
    static contextType = SiteContentContext;

    componentDidMount() {
        function loadScript(src) {
            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            });
        }

        loadScript('./assets/js/custom.js');
    }

    getProductsForCategory = (categoryKey) => {
        const content = this.context?.content || {};
        const configuredProducts = getByPath(content, `productCategories.${categoryKey}.items`, []);
        const fallbackProducts = fallbackCategoryProducts[categoryKey] || fallbackCategoryProducts.apartment;

        if (!Array.isArray(configuredProducts) || configuredProducts.length === 0) {
            return fallbackProducts.map((item) => ({
                ...item,
                imageUrls: Array.isArray(item.imageUrls) && item.imageUrls.length ? item.imageUrls : [item.image].filter(Boolean),
            }));
        }

        return configuredProducts.map((item, index) => {
            const fallback = fallbackProducts[index % fallbackProducts.length];
            const imageUrls = normalizeProductImageUrls(item, fallback.image);
            const primaryImage = imageUrls[0] || fallback.image;

            return {
                image: primaryImage,
                imageUrls,
                name: item?.name || item?.title || fallback.name,
                code: item?.code || fallback.code || '-',
                description: item?.description || fallback.description || '',
            };
        });
    };

    render() {
        const { title, categoryKey, pagename, description } = this.props;
        const content = this.context?.content || {};
        const products = this.getProductsForCategory(categoryKey);
        const categoryBannerUrl = getByPath(content, `productCategories.${categoryKey}.bannerImageUrl`, '');
        const sharedBannerUrl = getByPath(content, 'media.pages.productCategoriesBanner', '');
        const bannerImage = resolveMediaSrc(categoryBannerUrl || sharedBannerUrl, bnrimg);

        return (
            <>
                <Header />
                <div className="page-content">
                    <Banner
                        className="product-category-banner single-line-banner"
                        title={title}
                        pagename={pagename || title}
                        description={description || `${title} kategorisindeki urunleri inceleyebilirsiniz.`}
                        bgimage={bannerImage}
                    />
                    <div className="section-full p-t120 p-b90 bg-white mobile-page-padding">
                        <div className="container">
                            <div className="row d-flex justify-content-center">
                                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 m-b30">
                                    <div className="row product-category-grid">
                                        {products.map((item, index) => (
                                            <div key={index} className="col-lg-4 col-md-6 m-b30 product-category-grid-col">
                                                {(() => {
                                                    const relatedProducts = products
                                                        .filter((_, productIndex) => productIndex !== index)
                                                        .slice(0, 4)
                                                        .map((product) => ({
                                                            image: product.image,
                                                            imageUrls: Array.isArray(product.imageUrls) ? product.imageUrls : [product.image].filter(Boolean),
                                                            title: product.name,
                                                            code: product.code,
                                                            description: product.description || '',
                                                        }));

                                                    const detailState = {
                                                        categoryKey,
                                                        product: {
                                                            image: item.image,
                                                            imageUrls: Array.isArray(item.imageUrls) ? item.imageUrls : [item.image].filter(Boolean),
                                                            title: item.name,
                                                            code: item.code,
                                                            description: item.description || '',
                                                        },
                                                        relatedProducts,
                                                    };

                                                    return (
                                                <div className="sx-box sx-product-box overflow-hide product-category-card">
                                                    <div className="sx-thum-bx sx-img-overlay1 product-category-thumb">
                                                        <img className="product-category-thumb-image" src={item.image} alt={item.name} />
                                                        <div className="item-cart-view">
                                                            <div className="item-cart-btn">
                                                                <NavLink to="/urun-detay" state={detailState}><i className="fa fa-search" /></NavLink>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="sx-info p-t20 text-center product-category-info">
                                                        <h5 className="sx-title product-category-title">
                                                            <NavLink to="/urun-detay" state={detailState}>{item.name}</NavLink>
                                                        </h5>
                                                        <p className="m-b0 product-code-text">
                                                            {item.code || '-'}
                                                        </p>
                                                    </div>
                                                </div>
                                                    );
                                                })()}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </>
        );
    }
}

export default ProductCategoryGridPage;
